import { useQuery } from "@tanstack/react-query";
import adminApiClient from "api/admin";

const STUDIO_UPDATES_QUERY_KEY = "studio-updates";
const STUDIO_REPO = "klydo-studio";

const useStudioCommits = () => {
  return useQuery({
    queryKey: [STUDIO_UPDATES_QUERY_KEY],
    queryFn: () => adminApiClient.getStudioCommits(STUDIO_REPO),
  });
};

export default useStudioCommits;
